// src/services/paymentService.js
import axios from "axios";

const API = import.meta.env.VITE_API_URL || "https://cuvia.ro/api";

export const createPaymentIntent = (data) =>
  axios.post(`${API}/bookings/create-payment-intent`, data).then(r => r.data);

export const confirmBooking = (data) =>
  axios.post(`${API}/bookings/confirm`, data).then(r => r.data);
